// extracted by mini-css-extract-plugin
module.exports = {"item":"ApplyStatusField_item__1JCDw","text":"ApplyStatusField_text__1J19B","selectedDropdown":"ApplyStatusField_selectedDropdown__3xYy_"};